'use strict';

angular.module('internal.admin')
    .controller('InternalAdminEnterprise', ['$scope', '$stateParams', 'Enterprise', function ($scope, $stateParams, Enterprise) {
        $scope.masterEnterprise = $stateParams.enterprise;
        $scope.enterprise = $stateParams.enterprise;
        $scope.enterpriseID = $stateParams.id;
        $scope.enterpriseLoading = true;

        $scope.setMasterEnterprise = function (enterprise) {
            $scope.masterEnterprise = enterprise;
            $scope.enterprise = angular.copy($scope.masterEnterprise);
        }

        $scope.resetEnterprise = function () {
            if ($scope.masterEnterprise == null) {
                $scope.masterEnterprise = {};
            }
            $scope.enterprise = angular.copy($scope.masterEnterprise);
        }

        $scope.getEnterprise = function () {
            Enterprise.get({ enterpriseID: $stateParams.id }).then(function (enterprise) {
                $scope.enterpriseLoading = false;
                $scope.setMasterEnterprise(enterprise);
            })
        }

        if ($stateParams.id != null) {
            $scope.getEnterprise();
        }
        else {
            var enterprise = {};
            $scope.enterpriseLoading = false;
            $scope.setMasterEnterprise(enterprise);
        }
    }])
;